import React from "react";
import EmploymentHistoryForm from "../../components/EmploymentHistoryForm";

const EmploymentHistoryPage: React.FC = () => {
  return <EmploymentHistoryForm />;
};

export default EmploymentHistoryPage;
